import { IResultWithPagination } from 'reducers/models';

export type ICbls = IResultWithPagination<ICbl>;
export interface ICbl {
	equipmentId: number;
}
export interface IEquipments {
	id: number;
	bookingSplitId?: number;
	essoRateDetailSplitId?: number;
	equipmentNumber: string;
	containerSizeType: string;
	substitutionSizeType: string;
	primaryDocumentNumber: string;
	bookingNumber: string;
	quantity: string | number;
	select: boolean;
}
export interface IExportJob {
	exportJobId: number;
	essoRateDetailId?: number;
	finNumber: string;
	splits: IEquipments[];
	consignee?: IParty;
	party: string;
	icbIndicator: string;
	shipper?: IParty;
	partyDetails: string;
	quantity?: number;
	select?: boolean;
	status?: string;
	itemNumber?: string;
	rowVersion?: string;
}
export interface IParty {
	name: string;
	beCode: string;
	factCode: string;
	scvCode: string;
}
export interface ICblDetail {
	cblId: number;
	notificationIndicator: boolean;
	number: string;
	internalNumber: string;
	carrierBookingReference: string;
	consigneeName: string;
	consigneeFACTCode: string;
	consigneeCountryCode: string;
	consigneeSCVCode: string;
	shipperName: string;
	shipperFACTCode: string;
	shipperBusinessEntityCode: string;
	shipperCountryCode: string;
	shipperSCVCode: string;
	transportContractNumber: string;
	placeOfDeliveryCode: string;
	placeOfDeliveryName: string;
	carrierCountryCode: string;
	carrierBusinessEntityCode: string;
	carrierName: string;
	carrierFACTCode: string;
	carrierCode: string;
	originalPortOfLoadingCode: string;
	originalPortOfLoadingName: string;
	finalPortOfDischargeCode: string;
	finalPortOfDischargeName: string;
	insertDate: string;
	updateDate: string;
	createdBy: string;
	updatedBy: string;
	type: string;
	lastUpdatedBy: string;
	lastUpdatedByExportJobId: number;
	lastUpdatedByFcrId?: number;
	incoTerms: string;
	originOffice: string;
	shipmentType: string;
	voyages: any[];
	clrs: any[];
	documents: any[];
	equipments: any[];
	equipmentTransportShipments: any[];
	bookings: any[];
	billingDocuments: any[];
	shipments: any[];
	opsStatus: string;
	costAndRevenueSplits: any[];
	weight: number;
	volume: number;
	packages: number;
	quantity: number;
}

export const EmptyCblDetail = {
	cblId: 0,
	notificationIndicator: false,
	number: '',
	internalNumber: '',
	opsStatus: '',
	carrierBookingReference: '',
	consigneeName: '',
	consigneeFACTCode: '',
	consigneeCountryCode: '',
	consigneeSCVCode: '',
	shipperName: '',
	shipperFACTCode: '',
	shipperBusinessEntityCode: '',
	shipperCountryCode: '',
	shipperSCVCode: '',
	transportContractNumber: '',
	placeOfDeliveryCode: '',
	placeOfDeliveryName: '',
	carrierCountryCode: '',
	carrierBusinessEntityCode: '',
	carrierName: '',
	carrierFACTCode: '',
	carrierCode: '',
	originalPortOfLoadingCode: '',
	originalPortOfLoadingName: '',
	finalPortOfDischargeCode: '',
	finalPortOfDischargeName: '',
	insertDate: '',
	updateDate: '',
	createdBy: '',
	updatedBy: '',
	type: '',
	lastUpdatedBy: '',
	lastUpdatedByExportJobId: 0,
	lastUpdatedByFcrId: 0,
	incoTerms: '',
	originOffice: '',
	shipmentType: '',
	voyages: [],
	clrs: [],
	documents: [],
	equipments: [],
	equipmentTransportShipments: [],
	bookings: [],
	shipments: [],
	billingDocuments: [],
	costAndRevenueSplits: [],
	packages: 0,
	volume: 0,
	quantity: 0,
	weight: 0,
};

// For new CBL
export interface IChargeItem extends IChargeItemExtraFields {
	materialCode: string;
	materialDescription: string;
	quantity: number;
	unitOfMeasure: string;
	rate: number;
	itemType: string;
	condCurrency: string;
	localCurrency: string;
	exchangeRate: number;
	distribution: number;
	essoRateDistributions: ICostRevenue[];
	passThrough: string;
	serviceRenderedAt: string;
	vatPartner: string;
	vatPartnerReasonCodeNo: string;
}
export interface ICostRevenue {
	exportJobId?: number;
	essoRateDetailId?: number;
	party: string;
	partyDetails: string;
	icbIndicator: string;
	rowVersion?: string;
	quantityDistributions: IChargeQuantityDistribution[];
}
export interface IChargeQuantityDistribution {
	select: boolean;
	bookingSplitId: number;
}

// extra fields for UI
export interface IChargeItemExtraFields {
	id: number;
	children: IExportJob[];
	errorReason: string;
	handleError: boolean;
	displayDistribution: boolean;
	totalLocalCurrency: string;
	total: string;
	delete: string;
	isSameParty: boolean;
	updateChildrenStatus: boolean;
	party: string;
	partyDetails: string;
	icbIndicator: string;
	partyName: string;
	isOthers: boolean;
	others: string;
	itemType: string;
}

export interface ISaveCostRevenue {
	sourceId: string;
	insertBy: string;
	cblCostItems?: IChargeItem[];
	cblRevenueItems?: IChargeItem[];
}

export interface IEditChargeItem extends IChargeItem {
	chargeItemId?: number;
	reasonCode?: string;
}
export interface IEditCostRevenue {
	sourceId: string;
	updatedBy: string;
	cblCostItems?: IEditChargeItem[];
	cblRevenueItems?: IEditChargeItem[];
}
